// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"298":"3-render-mainrenderer","323":"3-render-failurerenderer","660":"2-polyfill-idle"}[chunkId] || chunkId) + ".js";
};